import type { FC } from 'react';

import { DownloadIcon } from '../../assets/icons/icons';
import styles from './GuideCard.module.scss';
import React from 'react';

interface GuideCardProps {
    /** Половинная ширина: декоративная страница скрыта, текст короче. */
    compact?: boolean;
    onDownload: () => void;
}

export const GuideCard: FC<GuideCardProps> = ({ compact = false, onDownload }) => (
    <div className={`${styles.card} ${compact ? styles.compact : ''}`}>
        <div className={styles.copy}>
            <div className={styles.eyebrow}>Руководство пользователя</div>

            <h3>Как работать с сервисом предиктивной аналитики</h3>

            <p>Пошаговая инструкция: от создания проекта до проверки найденных предложений.</p>

            <div className={styles.meta}>
                <span>PDF</span>
                <i />
                <span>Полная инструкция</span>
            </div>

            <button type="button" className={styles.cta} onClick={onDownload}>
                <DownloadIcon />
                Скачать руководство
            </button>
        </div>

        {/* Декоративная «страница» документа: чистая графика, без смысла для скринридера. */}
        <div className={styles.preview} aria-hidden="true">
            <span className={styles.fold} />
            <div className={`${styles.line} ${styles.w1}`} />
            <div className={`${styles.line} ${styles.w2}`} />
            <div className={`${styles.line} ${styles.w3}`} />
            <div className={`${styles.line} ${styles.w4}`} />
        </div>
    </div>
);